<ng-container *transloco="let t; read: 'user'">
<div class="p-5">
  <div class="flex flex-row justify-between gap-3">
    <drdp-title [title]="title"></drdp-title>
    <a class="self-center text-sm order-last cursor-pointer" routerLink="/portfolio-messages"><i
    class="uil uil-angle-left-b text-base"></i>{{ t('dashboard.portfolio.messages.backToMessages') }}</a>
  </div>

  <div class="my-5 flex flex-row justify-between gap-3">
    <div class="flex gap-3">
      <drdp-btn [color]="messageBg" type="button" (click)="handleTabChange(false)">{{ t('dashboard.portfolio.messages.messagesTab') }}</drdp-btn>
      <drdp-btn [color]="archiveBg" type="button" (click)="handleTabChange(true)">{{ t('dashboard.portfolio.messages.archivedTab') }}</drdp-btn>
    </div>
    <div class="flex gap-3">
      <div class="text-right">
        <drdp-btn color="outline" (click)="addToMessageBoard()" type="button">
          <i class="text-drdpblue-300 text-xl uil uil-envelope"></i>
        {{ t('dashboard.portfolio.reviewEvidence.addToMessageBoard') }}</drdp-btn>
      </div>
      <div class="text-right">
        <drdp-btn color="outline" (click)="viewStudentEvidence()" type="button">
          <i class="text-drdpblue-300 text-xl uil uil-notes"></i>
        {{ t('dashboard.portfolio.messages.viewStudentEvidence') }}</drdp-btn>
      </div>
    </div>
  </div>
  @for (message of portfolioMessages; track message) {
    <div>
      <drdp-message-board-tile [message]="message" [senderName]="senderName" [isArchived]="isArchived" (archiveMessage)="archivePortfolioMessage($event)">
      </drdp-message-board-tile>
    </div>
  }

  <div>
    <mat-paginator
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSize"
      [length]="totalData"
      [pageIndex]="pageIndex"
      (page)="paginateTable(false)">
    </mat-paginator>
  </div>
</div>
</ng-container>
